/* eslint-disable no-throw-literal */
/* eslint-disable no-lonely-if */
/* eslint-disable no-undef */
/* eslint-disable max-classes-per-file */
/* eslint-disable prefer-template */
/* eslint-disable arrow-body-style */
(() => {
  class RemoveItem extends HTMLElement {
    connectedCallback() {
      const deleteBtn = this.querySelector("button");
      deleteBtn.addEventListener("click", () => {
        const eventDelete = new CustomEvent("deleteLineItem", {
          bubbles: true,
          detail: deleteBtn.getAttribute("data-line-item"),
        });
        deleteBtn.dispatchEvent(eventDelete);
      });
    }
  }

  customElements.define("remove-line-item", RemoveItem);

  class Cart extends HTMLElement {
    constructor() {
      super();
      this.cartDrawer = this.parentElement;
      this.loadingSpinner = this.querySelector(".cart-drawer__overlay");
      this.cartOpener = document.querySelector(".js-cart-drawer-opener");
    }

    connectedCallback() {
      this.handleCartAnimation();

      this.addEventListener("deleteLineItem", (e) => {
        this.updateQuantity(e.detail, 0);
      });

      this.addEventListener("changeQuantity", (e) => {
        this.updateQuantity(e.detail.id, e.detail.qty);
      });

      this.addEventListener("changeQuantityPlus", (e) => {
        const formData = {
          items: [
            {
              id: e.detail.id,
              quantity: e.detail.qty,
            },
          ],
        };
        this.addToCart(formData);
      });
    }

    async handleError(e) {
      if (e) {
        if (e.status === 422) {
          await this.updateCart();
          const failedText = document.createElement("p");
          failedText.classList.add("body-black", "cart-drawer__error");
          failedText.innerText = `${e.message}`;
          this.querySelector(".cart-header").append(failedText);
          if (this.loadingSpinner) {
            this.loadingSpinner.classList.add("hidden");
          }
          return;
        }
      }
      await this.updateCart();
      const failedText = document.createElement("p");
      failedText.classList.add("body-black", "cart-drawer__error");
      failedText.innerText =
        "Etwas ist schiefgelaufen. Probiere es bitte später erneut.";
      this.querySelector(".cart-header").append(failedText);
      if (this.loadingSpinner) {
        this.loadingSpinner.classList.add("hidden");
      }
    }

    reattachCloser() {
      const cartDrawer = this.parentElement;

      const cartCloser = this.querySelector(".js-cart-drawer-closer");

      function closeDrawer() {
        cartDrawer.close();
        document.body.classList.remove("remove-scrolling");
      }

      cartCloser.addEventListener("click", () => {
        closeDrawer();
      });
    }

    handleCartAnimation() {
      const cartDrawer = this.parentElement;

      const cartOpener = document.querySelectorAll(".js-cart-drawer-opener");

      const cartCloser = this.querySelector(".js-cart-drawer-closer");

      function closeDrawer() {
        document.body.classList.remove("remove-scrolling");
        cartDrawer.close();
      }

      cartOpener.forEach((opener) => {
        opener.addEventListener("click", () => {
          cartDrawer.showModal();
          document.body.classList.add("remove-scrolling");
          this.fetchCartData();
        });
      });

      cartCloser.addEventListener("click", () => {
        closeDrawer();
      });

      cartDrawer.addEventListener("click", (e) => {
        const dialogDimensions = cartDrawer.getBoundingClientRect();
        if (
          e.clientX < dialogDimensions.left ||
          e.clientX > dialogDimensions.right ||
          e.clientY < dialogDimensions.top ||
          e.clientY > dialogDimensions.bottom
        ) {
          closeDrawer();
        }
      });

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'open' &&
            cartDrawer.open
          ) {
            this.fetchCartData();
          }
        });
      });

      observer.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['open'],
      });
    }

    async addToCart(formData) {
      this.cartOpener.click();
      if (this.loadingSpinner) {
        this.loadingSpinner.classList.remove("hidden");
      }

      try {
        const response = await fetch(
          `${window.Shopify.routes.root}cart/add.js`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          }
        );
        const responseJson = await response.json();
        if (!response.ok) {
          throw {
            message: responseJson.message,
            status: responseJson.status,
          };
        }

        this.updateCart();
      } catch (error) {
        this.handleError(error);
      }
    }

    async updateCart() {
      if (this.loadingSpinner) {
        this.loadingSpinner.classList.remove("hidden");
      }
      try {
        const response = await fetch(
          `${routes.cart_url}/?section_id=cart-drawer`
        );
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const selectors = [
          ".cart-header",
          ".cart-footer",
          ".cart-drawer__list-items",
          ".cart-comment",
        ];
        selectors.forEach((selector) => {
          switch (selector) {
            case ".cart-drawer__list-items": {
              const targetElement = this.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (!sourceElement) {
                if (targetElement) {
                  targetElement.remove();
                }
              } else {
                if (!targetElement) {
                  this.querySelector(".cart-drawer__body").prepend(
                    sourceElement
                  );
                } else {
                  targetElement.replaceWith(sourceElement);
                }
              }
              break;
            }

            case ".cart-comment": {
              const targetElement = this.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              const cartBody = this.querySelector(".cart-drawer__body");
              if (sourceElement) {
                if (targetElement) {
                  targetElement.replaceWith(sourceElement);
                } else if (cartBody) {
                  cartBody.appendChild(sourceElement);
                }
              } else if (targetElement) {
                targetElement.remove();
              }
              break;
            }

            default: {
              const targetElement = this.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
              break;
            }
          }
        });
        this.reattachCloser();
        if (this.loadingSpinner) {
          this.loadingSpinner.classList.add("hidden");
        }
        const cartItemHolder = this.querySelector(".cart-drawer__list-items");
        if (cartItemHolder) {
          let total = 0;
          cartItemHolder.querySelectorAll(".js-qty-input").forEach((input) => {
            total += parseInt(input.value, 10);
          });
          document
            .querySelectorAll(".js-header-bar__show-amount")
            .forEach((elem) => {
              elem.innerHTML = total;
            });
        }

        this.toggleDrawerRewards();

        // Fetch cart data and update milestones - hideGiftFromCartDisplay is called within updateProgress
        this.fetchCartData();
      } catch (error) {
        this.handleError(error);
      }
    }

    toggleDrawerRewards() {
      const drawerRewards = this.querySelector('.drawer-rewards');
      if (!drawerRewards) return;

      drawerRewards.style.display = '';
      drawerRewards.style.visibility = '';
    }

    /**
     * Fetch cart data from Shopify API and update milestones
     */
    async fetchCartData() {
      try {
        const response = await fetch(
          `${window.Shopify?.routes?.root || '/'}cart.js`
        );
        if (!response.ok) return;
        this.cartData = await response.json();

        if (window.cartMilestones) {
          window.cartMilestones.updateProgress(this.cartData);
        }
      } catch (error) {
        // Silently fail if cart fetch fails
      }
    }

    async updateQuantity(key, qty) {
      if (this.loadingSpinner) {
        this.loadingSpinner.classList.remove("hidden");
      }
      const updates = {};
      updates[key] = qty;

      try {
        const response = await fetch(
          window.Shopify.routes.root + "cart/update.js",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates }),
          }
        );

        const responseJson = await response.json();

        if (!response.ok) {
          throw {
            message: responseJson.message,
            status: responseJson.status,
          };
        }
        this.updateCart();
      } catch (error) {
        this.handleError(error);
      }
    }
  }

  customElements.define("cart-drawer", Cart);
})();
